import React from "react";

export const UserDetailsContext = React.createContext();